import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { BusinessErrorMessage, ErrorMessage, PartialSuccess, PendingReferral, Success } from './StatusMessage';
import { BUSINESS_ERROR_CODES_CLI, BUSINESS_ERROR_STATUS_CODE } from '../../../../const/business-error-codes';
import { ConfigContext } from '../../context';
export const getImages = ({ config }) => {
    const { assets } = config.hosts;
    return {
        success: `${assets}assets/account-services/cli_success.svg`,
        error: `${assets}assets/account-services/cli_unplugged_error.svg`,
        errorCat: `${assets}assets/account-services/technical_error_cat.svg`
    };
};
const StatusMessageHandler = ({ isError, isSuccess, creditLimitRequestResponse, creditLimit }) => {
    const { config } = useContext(ConfigContext);
    const fullApproval = creditLimitRequestResponse?.fullApproval;
    const newCreditLimit = creditLimitRequestResponse?.creditLimit;
    const statusCode = creditLimitRequestResponse?.statusCode;
    const businessErrorsCode = creditLimitRequestResponse?.businessErrors?.[0]?.code;
    const businessErrorsMessage = creditLimitRequestResponse?.businessErrors?.[0]?.message;
    const images = getImages({ config });
    const casesList = [
        {
            component: (_jsx(Success, { newCreditLimit: newCreditLimit ?? '', image: images.success })),
            rule: !isError && isSuccess && newCreditLimit && fullApproval
        },
        {
            component: (_jsx(PartialSuccess, { newCreditLimit: newCreditLimit ?? '', image: images.success })),
            rule: !isError && isSuccess && newCreditLimit && !fullApproval
        },
        {
            component: (_jsx(BusinessErrorMessage, { creditLimit: creditLimit ?? '', errorMessage: businessErrorsMessage || '' })),
            rule: statusCode === BUSINESS_ERROR_STATUS_CODE &&
                businessErrorsCode === BUSINESS_ERROR_CODES_CLI.Decline
        },
        {
            component: (_jsx(PendingReferral, { creditLimit: creditLimit ?? '', errorMessage: businessErrorsMessage || '' })),
            rule: statusCode === BUSINESS_ERROR_STATUS_CODE &&
                businessErrorsCode === BUSINESS_ERROR_CODES_CLI.Referral
        },
        {
            component: _jsx(ErrorMessage, { id: "cli-error", image: images.error }),
            rule: isError && statusCode !== BUSINESS_ERROR_STATUS_CODE
        }
    ];
    return (casesList.find(({ rule }) => rule)?.component ?? (_jsx(ErrorMessage, { id: "cli-error", image: images.error })));
};
export default StatusMessageHandler;
